<div class="w-screen max-w-xl p-4">
  <div class="rounded-lg bg-white shadow">
    <!-- Header -->
    <div
      class="flex items-center justify-between border-b border-gray-200 p-4 sm:p-5">
      <h3 class="text-xl font-bold text-gray-900">Patient Handout</h3>
      <button
        type="button"
        aria-label="Close"
        class="inline-flex rounded-lg p-1.5 text-gray-400 hover:bg-gray-200 hover:text-gray-900"
        (click)="close()">
        <svg
          class="h-5 w-5"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true">
          <path
            fill-rule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"></path>
        </svg>
      </button>
    </div>

    <!-- Body -->
    <div class="p-4 sm:p-5">
      @switch (step()) {
        @case ('select') {
          <fieldset class="space-y-1">
            @for (option of options; track option.value) {
              <label
                class="flex items-start gap-3 rounded-lg p-3"
                [class]="
                  option.disabled
                    ? 'cursor-not-allowed opacity-50'
                    : 'cursor-pointer hover:bg-gray-50'
                ">
                <input
                  type="radio"
                  name="handout-option"
                  class="mt-1"
                  [checked]="selected() === option.value"
                  [disabled]="option.disabled"
                  (change)="select(option.value)" />
                <span>
                  <span class="block font-medium text-gray-900">
                    {{ option.label }}
                  </span>
                  @if (option.description) {
                    <span class="block text-sm text-gray-500">
                      {{ option.description }}
                    </span>
                  }
                </span>
              </label>
            }
          </fieldset>
        }
        @case ('generating') {
          <div
            class="flex min-h-[16rem] flex-col items-center justify-center gap-3 text-center">
            <icaredx-spinner size="medium" />
            <p class="text-sm text-gray-500">Generating the handout…</p>
          </div>
        }
        @case ('preview') {
          <div
            class="rich-text-reset max-h-[60vh] overflow-auto rounded-lg border border-gray-200 p-4 text-sm text-gray-800"
            [innerHTML]="previewHtml()"></div>
        }
      }
    </div>

    <!-- Footer -->
    <div
      class="flex items-center justify-end gap-3 border-t border-gray-200 p-4 sm:p-5">
      @switch (step()) {
        @case ('select') {
          <icaredx-button color="secondary" (clicked)="close()">
            Cancel
          </icaredx-button>
          <icaredx-button (clicked)="create()">Create Handout</icaredx-button>
        }
        @case ('preview') {
          <icaredx-button color="secondary" (clicked)="close()">
            Cancel
          </icaredx-button>
          <icaredx-button [disabled]="sharing()" (clicked)="share()">
            Send to patient
          </icaredx-button>
        }
      }
    </div>
  </div>
</div>
